/* FAQ View Styles */
.wrapper {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px clamp(16px, 4vw, 48px);
}

/* Header */
.header {
  margin-bottom: 24px;
}

.title {
	font-size: 1.5rem;
	font-weight: 600;
	color: var(--foreground);
	margin: 0 0 8px;
}

.dark .title {
  color: var(--foreground);
}

.subtitle {
	font-size: 0.875rem;
	color: var(--muted-foreground);
	margin: 0;
}

.dark .subtitle {
  color: var(--muted-foreground);
}

/* Navigation Row */
.navRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: nowrap;
}

/* Tabs */
.tabs {
  display: flex;
  gap: 4px;
  flex-wrap: nowrap;
  min-width: 0;
  flex: 1;
  overflow: hidden;
}

.tab {
	padding: 8px 12px;
	border-radius: 20px;
	border: 1px solid var(--border);
	background: var(--secondary);
	color: var(--muted-foreground);
	font-size: 0.8125rem;
	font-weight: 500;
	cursor: pointer;
	white-space: nowrap;
	flex-shrink: 1;
	min-width: max-content;
	transition: all 0.2s;
}

.tab:hover {
  background: var(--secondary);
  color: var(--foreground);
}

.dark .tab {
  background: var(--secondary);
  border-color: var(--border);
  color: var(--muted-foreground);
}

.dark .tab:hover {
  background: #404040;
  color: #D7DADC;
}

.tab.active {
  background: color-mix(in oklch, var(--primary) 10%, transparent);
  border-color: color-mix(in oklch, var(--primary) 30%, transparent);
  color: var(--primary);
}

.tab.active:hover {
  background: color-mix(in oklch, var(--primary) 15%, transparent);
  color: var(--primary);
}

.dark .tab.active {
  background: color-mix(in oklch, var(--primary) 20%, transparent);
  border-color: color-mix(in oklch, var(--primary) 40%, transparent);
  color: var(--primary);
}

/* Search */
.searchWrapper {
  position: relative;
  flex-shrink: 0;
  width: clamp(180px, 20vw, 300px);
}

.searchInput {
	width: 100%;
	padding: 12px 40px 12px 16px;
	border-radius: 8px;
	border: 1px solid #e0e0e0;
	background: var(--background);
	color: var(--foreground);
	font-size: 0.875rem;
	outline: none;
	transition:
		border-color 0.2s,
		box-shadow 0.2s;
}

.searchInput:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px color-mix(in oklch, var(--primary) 10%, transparent);
}

.searchInput::placeholder {
  color: #999;
}

.dark .searchInput {
  background: #2a2a2a;
  border-color: #4b4b4b;
}

.dark .searchInput:focus {
  box-shadow: 0 0 0 3px color-mix(in oklch, var(--primary) 20%, transparent);
}

.dark .searchInput::placeholder {
  color: #666;
}

.searchIcon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  pointer-events: none;
}

.dark .searchIcon {
  color: #666;
}

/* Content */
.content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.resultsLabel {
	font-size: 0.875rem;
	color: #666;
	margin-bottom: 8px;
}

.dark .resultsLabel {
  color: #888;
}

/* Accordion */
.accordionItem {
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background: var(--background);
  overflow: hidden;
  transition: box-shadow 0.2s;
}

.accordionItem:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.dark .accordionItem {
  background: #252525;
  border-color: #4b4b4b;
}

.dark .accordionItem:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.question {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border: none;
  background: #fafafa;
  text-align: left;
  cursor: pointer;
  gap: 12px;
  transition: background-color 0.2s;
}

.question:hover {
  background: #f0f0f0;
}

.dark .question {
  background: #2a2a2a;
  color: #D7DADC;
}

.dark .question:hover {
  background: #333;
}

.questionText {
	font-size: 0.875rem;
	font-weight: 500;
	color: #1a1a1a;
	flex: 1;
	padding-right: 16px;
}

.dark .questionText {
  color: #D7DADC;
}

.categoryBadge {
	font-size: 0.75rem;
	font-weight: 500;
	padding: 2px 8px;
	border-radius: 4px;
	background: #f0f0f0;
	color: #888;
	margin-left: 8px;
}

.dark .categoryBadge {
  background: #333;
  color: #999;
}

.chevron {
  width: 20px;
  height: 20px;
  color: #666;
  transition: transform 0.2s;
  flex-shrink: 0;
}

.chevron.open {
  transform: rotate(180deg);
}

.dark .chevron {
  color: #888;
}

.answer {
	padding: 16px;
	font-size: 0.875rem;
	line-height: 1.6;
	color: #444;
	background: #fff;
	border-top: 1px solid #e0e0e0;
	white-space: pre-wrap;
}

.dark .answer {
  color: #bbb;
  background: #202020;
  border-top-color: #4b4b4b;
}

/* FAQ Images */
.inlineImg {
  display: inline-block;
  height: 1.4em;
  width: auto;
  vertical-align: middle;
  margin: 0 4px;
  border-radius: 3px;
}

.dark .inlineImg {
  filter: brightness(0.9);
}

.blockImg {
  display: block;
  max-width: 400px;
  height: auto;
  margin: 16px 0;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.dark .blockImg {
  border-color: #4b4b4b;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.smallImg {
  display: block;
  max-width: 250px;
  height: auto;
  margin: 16px 0;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.dark .smallImg {
  border-color: #4b4b4b;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.lgBlockImg {
  display: block;
  max-width: 100%;
  width: 700px;
  height: auto;
  margin: 16px 0;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.dark .lgBlockImg {
  border-color: #4b4b4b;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.sideImg {
  display: inline-block;
  max-width: 45%;
  width: 300px;
  height: auto;
  margin: 8px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  vertical-align: middle;
}

.dark .sideImg {
  border-color: #4b4b4b;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

/* No Results */
.noResults {
  text-align: center;
  padding: 48px 24px;
  color: #666;
}

.noResults svg {
  margin-bottom: 16px;
  opacity: 0.3;
}

.noResults p {
	font-size: 1rem;
	font-weight: 500;
	margin: 0 0 4px;
}

.noResults span {
	font-size: 0.875rem;
}

.dark .noResults {
  color: #888;
}

/* Video Cards */
.videoGrid {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.videoCard {
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background: var(--background);
  overflow: hidden;
  transition: box-shadow 0.2s;
}

.videoCard:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.dark .videoCard {
  background: #252525;
  border-color: #4b4b4b;
}

.dark .videoCard:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.videoEmbed {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #000;
}

.videoEmbed iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.videoCaption {
	padding: 12px 16px;
	font-size: 0.875rem;
	color: #666;
	margin: 0;
	line-height: 1.5;
	background: #fafafa;
	border-top: 1px solid #e0e0e0;
}

.dark .videoCaption {
  color: #999;
  background: #2a2a2a;
  border-top-color: #4b4b4b;
}

/* Mobile */
@media (max-width: 768px) {
  .wrapper {
    padding: 24px 16px;
  }

	.title {
		font-size: 1.375rem;
	}

  .navRow {
    flex-direction: column;
    align-items: stretch;
  }

  .tabs {
    overflow-x: auto;
    padding-bottom: 8px;
  }

  .searchWrapper {
    width: 100%;
  }
}
